import { ProductBreadcrumbs } from '../../molecules/ProductBreadcrumbs/ProductBreadcrumbs';
import { MyAssetsTabs } from '../../organisms/MyAssetsTabs/MyAssetsTabs';
import { MyAssetsTemplateProps } from './MyAssetsTemplate.types';

export const MyAssetsTemplate = ({
  breadcrumbs,
  tabs,
  microcopy,
  ...actions
}: MyAssetsTemplateProps) => {
  return (
    <div className="lg-container min-h-[25rem] space-y-5 pb-10 pt-4 lg:space-y-7 lg:pb-16">
      <ProductBreadcrumbs path={breadcrumbs.path} />
      <MyAssetsTabs {...tabs} {...actions} microcopy={microcopy} />
    </div>
  );
};
